module.exports = __webpack_public_path__ + "static/contact-mobile-40b51b68383790de34645b93012fa822.png";